import { Drawer } from 'antd';
import InicioMantencionConfirm from 'components/mantenciones/InicioMantencionConfirm';

const ConfirmarInicioMantencionDrawer = ({ solicitud, open, onClose }) => (
  <Drawer
    title="Confirmar inicio de mantención"
    placement="bottom"
    height="auto"
    open={open}
    onClose={onClose}
    destroyOnHidden
  >
    {open && solicitud && <InicioMantencionConfirm solicitud={solicitud} onCancel={onClose} />}
  </Drawer>
);

export default ConfirmarInicioMantencionDrawer;
